import { GetterTree } from 'vuex';
import { LoginState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<LoginState, RootState> = {
    loginSTS(state): boolean {
        const { isAuth } = state;
        return (isAuth) ? true : false;
    },
};

